
  <!-- Message Popup Dialog -->
  <div *ngIf="showMessagePopup" class="admin-message-popup-overlay">
    <div class="admin-message-popup">
      <h3>Message Detail</h3>
      <pre style="white-space: pre-wrap;word-break:break-word;max-height:60vh;overflow:auto;">{{ popupMessage }}</pre>
      <button (click)="closeMessagePopup()">Close</button>
    </div>
  </div>
  
<div class="admin-header-blue">
  <span class="admin-header-blue-icon" aria-hidden="true">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="10" r="5" fill="#fff" fill-opacity="0.7"/>
      <ellipse cx="14" cy="20" rx="8" ry="4" fill="#fff" fill-opacity="0.35"/>
    </svg>
  </span>
  <div>
    <h2>Admin Panel</h2>
  </div>
</div>
<div class="admin-tabs">
  <button [class.active]="selectedTab === 0" (click)="selectTab(0)">Usage Logs</button>
  <button [class.active]="selectedTab === 1" (click)="selectTab(1)">Error Logs</button>
  <button [class.active]="selectedTab === 2" (click)="selectTab(2)">Update Claim</button>
  <button [class.active]="selectedTab === 3" (click)="selectTab(3)">Dashboard</button>
</div>

<div class="admin-tab-content">
  <div *ngIf="selectedTab === 0" class="admin-grid">
    <div class="filter-row">
      <label>Search Message:
        <input type="text" [(ngModel)]="usageMessageFilter" (input)="filterUsageLogs()" placeholder="Search message..." />
      </label>
      <label>Start Timestamp:
        <input type="datetime-local" [(ngModel)]="usageStartDate" (change)="filterUsageLogs()" />
      </label>
      <label>End Timestamp:
        <input type="datetime-local" [(ngModel)]="usageEndDate" (change)="filterUsageLogs()" />
      </label>
      <button (click)="usageStartDate=''; usageEndDate='';usageMessageFilter=''; filterUsageLogs()">Clear</button>
    </div>
    <ag-grid-angular
      style="width: 100%; height: 600px;"
      class="ag-theme-alpine"
      theme="legacy"
      [rowData]="filteredLogData1"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [pagination]="true"
      [paginationPageSize]="20">
    </ag-grid-angular>
  </div>
  <div *ngIf="selectedTab === 1" class="admin-grid">
    <div class="filter-row">
      <label>Search Message:
        <input type="text" [(ngModel)]="errorMessageFilter" (input)="filterErrorLogs()" placeholder="Search message..." />
      </label>
      <label>Start Timestamp:
        <input type="datetime-local" [(ngModel)]="errorStartDate" (change)="filterErrorLogs()" />
      </label>
      <label>End Timestamp:
        <input type="datetime-local" [(ngModel)]="errorEndDate" (change)="filterErrorLogs()" />
      </label>
      <button (click)="errorStartDate=''; errorEndDate=''; errorMessageFilter='';filterErrorLogs()">Clear</button>
    </div>
    <ag-grid-angular
      style="width: 100%; height: 600px;"
      class="ag-theme-alpine"
      theme="legacy"
      [rowData]="filteredLogData2"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [pagination]="true"
      [paginationPageSize]="20">
    </ag-grid-angular>
  </div>
  <div *ngIf="selectedTab === 2" class="admin-grid">
    <form (ngSubmit)="updateClaim()" #updateClaimForm="ngForm" class="update-claim-form">
      <div class="claim-fields-row">
        <div>
          <label>Reference Number:
            <input type="text" name="referenceNumber" [(ngModel)]="referenceNumber" required />
          </label>
        </div>
        <div>
          <label>Claim Number:
            <input type="text" name="newClaimNumber" [(ngModel)]="newClaimNumber" required />
          </label>
        </div>
      </div>
      <div>
        <button type="submit" [disabled]="!updateClaimForm.form.valid">Update</button>
      </div>
      <div *ngIf="updateClaimMessage" class="update-claim-message">{{ updateClaimMessage }}</div>
    </form>
  </div>
  <div *ngIf="selectedTab === 3" class="admin-grid">
    <div class="claim-fields-row">
      <div class="row row-cols-1 row-cols-md-2 mt-3">
        <div class="col mb-4">
          <div class="card radius-10 border-start border-0 border-3 border-info shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div>
                  <p class="mb-0 text-secondary font-weight-bold">Today's Transmit Count</p>
                  <h4 class="my-1 text-info">{{ totalTransmitCount || 0 }}</h4>
                </div>
                <div class="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto">
                  <i class="fa fa-paper-plane"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="card radius-10 border-start border-0 border-3 border-success shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div>
                  <p class="mb-0 text-secondary font-weight-bold">Weekly Transmit Count</p>
                  <h4 class="my-1 text-success">{{ weeklyTransmitCount || 0 }}</h4>
                </div>
                <div class="widgets-icons-2 rounded-circle bg-gradient-ohhappiness text-white ms-auto">
                  <i class="fa fa-calendar-check-o"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <!-- Claim IDs Grids -->
      <div class="row row-cols-1 row-cols-md-2 mt-3">
        <div class="col mb-4">
          <div class="card radius-10 border-start border-0 border-3 border-info shadow-sm h-100">
            <div class="card-body">
              <div>
                <p class="mb-0 text-secondary font-weight-bold">Claim Numbers Transmitted Today</p>
                <div *ngIf="this.claimIdsTransmittedToday.length; else noTodayClaims">
                  <table class="table table-sm table-bordered mt-2">
                    <thead><tr><th>Claim Number</th></tr></thead>
                    <tbody>
                      <tr *ngFor="let id of this.claimIdsTransmittedToday"><td><a [routerLink]="['/claim', id]">{{ id }}</a></td></tr>
                    </tbody>
                  </table>
                </div>
                <ng-template #noTodayClaims><span class="text-muted">No claims transmitted today.</span></ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="card radius-10 border-start border-0 border-3 border-success shadow-sm h-100">
            <div class="card-body">
              <div>
                <p class="mb-0 text-secondary font-weight-bold">Claim Numbers Transmitted This Week</p>
                <div *ngIf="this.claimIdsTransmittedThisWeek.length; else noWeekClaims">
                  <table class="table table-sm table-bordered mt-2">
                    <thead><tr><th>Claim Number</th></tr></thead>
                    <tbody>
                      <tr *ngFor="let id of this.claimIdsTransmittedThisWeek"><td><a [routerLink]="['/claim', id]">{{ id }}</a></td></tr>
                    </tbody>
                  </table>
                </div>
                <ng-template #noWeekClaims><span class="text-muted">No claims transmitted this week.</span></ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
